export const SET_SOCKET = "SET_SOCKET";

export function setSocket(socket = null) {
  return {
    type: SET_SOCKET,
    socket,
  };
}
